import type { ClassTypeWithPropertyType } from "@/tailwind/tailwindUtils";
import { useCodebaseStore } from "@/store/zustand/codebaseStore";
import type { PropertyType } from "@/tailwind/tailwindUtils";

export const useTailwindProperties = (type: PropertyType): ClassTypeWithPropertyType[] => {
  return useCodebaseStore((state) => state.propertiesForType?.[type]) || [];
};
